import { motion } from 'framer-motion'
import React from 'react'
import { FaFacebookF } from 'react-icons/fa'
import { GrLinkedinOption } from 'react-icons/gr'

const SocialMedia = () => (
  <motion.div
    whileInView={{ x: [0, 20], opacity: [0, 1] }}
    transition={{ duration: 0.3 }}
    className="app__social">
    <a
      href="https://www.linkedin.com/in/taramija/"
      rel="noreferrer"
      aria-label="social link linkedin"
      target="_blank">
      <GrLinkedinOption />
    </a>
    <div>
      <FaFacebookF />
    </div>
  </motion.div>
)

export default SocialMedia
